import { BUSCAR_VENDAS_URBANAS } from '../../actions/types'

const initial = { vendasUrbanas: [], total: 0 }

export default function reducerBuscarVendasUrbanas (state = initial, action = {}) {
  switch (action.type) {
    case BUSCAR_VENDAS_URBANAS: {
      return {
        vendasUrbanas: action.payload.vendasUrbanas || [],
        total: action.payload.total || 0
      }
    }

    default:
      return state
  }
}
